import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';


@Injectable({
	providedIn: 'root',
})
export class TlkService {
	token = sessionStorage.getItem('token');
	userName = sessionStorage.getItem('username');

	constructor(private http: HttpClient) {}

	private getHeaders(): HttpHeaders {
    return new HttpHeaders({
      Authorization: `Bearer ${this.token}`,
    });
  }

	getAllPlans(filters: any): Observable<any> {
		let params = new HttpParams();
    for (const key in filters) {
      if (filters.hasOwnProperty(key) && filters[key]) {
        params = params.set(key, filters[key]);
      }
    }

		return this.http.get(`${environment.tlkUrl}/plan/plantax/filter`, { headers: this.getHeaders(), params });
	}

	getPlanById(id: string): Observable<any> { 
		return this.http.get(`${environment.tlkUrl}/plan/${id}`, { headers: this.getHeaders() });
	}

	getTaxById(planId: string): Observable<any> {
		return this.http.get(`${environment.tlkUrl}/tax/by-plan/${planId}`, { headers: this.getHeaders() });
	}

	uploadPlans(plans: any[]): Observable<any> {
		let params = new HttpParams();
		params = params.set('username', this.userName);
		return this.http.post(`${environment.tlkUrl}/plan/process-file`, plans, { headers: this.getHeaders(), params });
	}

	getViewPackages(): Observable<any> {
		return this.http.get(`${environment.tlkUrl}/plan/vtlk`, { headers: this.getHeaders() });
	}

	approvePlan(planId: string): Observable<any> { 
		return this.http.put(`${environment.tlkUrl}/plan/approve/${this.userName}/${planId}`, {}, { headers: this.getHeaders() });
	}

	disapprovePlan(planId: string): Observable<any> { 
		return this.http.put(`${environment.tlkUrl}/plan/disapprove/${this.userName}/${planId}`, {}, { headers: this.getHeaders() });
	}

	updatePlan(planId: string, plan: any): Observable<any> {
		return this.http.put(`${environment.tlkUrl}/plan/${planId}`, plan, { headers: this.getHeaders() });
	}

	updateTax(taxId: string, tax: any): Observable<any> {
		return this.http.put(`${environment.tlkUrl}/tax/${taxId}`, tax, { headers: this.getHeaders() });
	}

	createPackages(packages: any): Observable<any> {
		return this.http.post(`${environment.tlkUrl}/planpackage`, packages, { headers: this.getHeaders() });
	}

	getPackages(): Observable<any> { 
		return this.http.get(`${environment.tlkUrl}/planpackage`, { headers: this.getHeaders() });
	}

	deletePackages(idPackage: string): Observable<any> {
		return this.http.delete(`${environment.tlkUrl}/planpackage/${idPackage}`, { headers: this.getHeaders() });
	}

	updateTableBrad(tableBrad: any): Observable<any> {
		return this.http.put(`${environment.tlkUrl}/tax/updateTableBrad?oldTableBrad=${tableBrad.oldTableBrad}&newTableBrad=${tableBrad.newTableBrad}`, {}, { headers: this.getHeaders() });
	}

}
